import React from "react";
import { AriaButtonProps } from "react-aria";

import { _IconButton, IconButtonProps } from "./_IconButton";

interface Props
  extends AriaButtonProps,
    Pick<
      IconButtonProps,
      | "icon"
      | "size"
      | "color"
      | "hoverFill"
      | "hoverColor"
      | "isLoading"
      | "shape"
      | "fill"
      | "hasDropShadow"
    > {
  slot?: string;
  testID?: string;
  className?: string;
  iconFill?: boolean;
}

export function GhostIconButton({
  color,
  hoverFill,
  iconFill,
  hoverColor,
  ...props
}: Props) {
  const { testID = "ghost-icon-button" } = props;

  return (
    <_IconButton
      color={color ? color : "icon-base"}
      focusStyle="focus-action"
      hoverColor={hoverColor ? hoverColor : "icon-base"}
      hoverFill={hoverFill ? hoverFill : "background-ghost-hover"}
      iconFill={iconFill}
      loaderColor="icon-success"
      testID={testID}
      {...props}
    />
  );
}
